import React, { FC } from "react";
import { Link } from "src/components/Link";
import { ActionBanner } from "src/components/ActionBanner";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { ReactComponent as PlusIcon } from "src/assets/icons/plus.svg";
import { Show } from "../PrivateRoute/Show";
import { ONLY_FOR, OnlyFor } from "../PrivateRoute/types";

interface Props {
  title: string;
  description: string;
  href: string;
  textButton: string;
  onlyFor?: OnlyFor;
}

export const NoItemsBanner: FC<Props> = ({
  title,
  description,
  href,
  textButton,
  onlyFor = ONLY_FOR.AUTHORIZED,
}) => (
  <ActionBanner className="!gap-3" title={title}>
    <p className="font-medium">{description}</p>
    <Show onlyFor={onlyFor}>
      <Link href={href}>
        <Button
          variant={ButtonVariants.SECONDARY}
          className="gap-2 px-5 py-2 !text-black-base font-medium"
        >
          <PlusIcon />
          <span>{textButton}</span>
        </Button>
      </Link>
    </Show>
  </ActionBanner>
);
